import { Typography } from '@material-ui/core';
import {
  categorizeOrderInsightRisks,
  getParentSeverity,
  PropertyOrderInsightsProps,
  RiskCategory,
} from 'api/file/interfaces/get-file-order-insights';
import clsx from 'clsx';
import React from 'react';
import OrderInsightAlert from './OrderInsightAlerts';
import OrderInsightsRiskIcon from './OrderInsightsRiskIcon';
import orderInsightStyles from './OrderInsightStyles';

const OwnerName: React.FC<PropertyOrderInsightsProps> = ({ property, isPdf }) => {
  const { alertRisks, warningRisks, unknownRisks, errorRisks } = categorizeOrderInsightRisks(
    property.risks,
    RiskCategory.OwnerName,
  );
  const classes = orderInsightStyles();

  return (
    <div className={classes.brdBtm}>
      <div className={clsx(classes.displayFlex, classes.flexGrow)}>
        <div className={classes.labelCol}>
          <span className={clsx(classes.displayFlex, classes.alignCenter)}>
            <OrderInsightsRiskIcon
              isPdf={isPdf}
              riskSeverity={getParentSeverity(property.risks, RiskCategory.OwnerName)}
            />
            <Typography
              variant="h4"
              color="textSecondary"
              className={clsx(classes.ml1, classes.fontSizeNormal, isPdf ? classes.bold : '')}
            >
              Owner Name:
            </Typography>
          </span>
        </div>
        <div className={classes.flexGrow}>
          <Typography variant="body1" className={clsx(classes.mb1, classes.fontSizeNormal)}>
            <strong className={classes.minWidth}>On File:</strong> {property.onFileOwnerNames?.join(' & ') || ''}
          </Typography>
          <Typography variant="body1" className={clsx(classes.mb1, classes.fontSizeNormal)}>
            <strong className={classes.minWidth}>Recorded:</strong> {property.ownerInformation?.ownerNames || ''}
          </Typography>
          <OrderInsightAlert
            isPdf={isPdf}
            alerts={alertRisks}
            warnings={warningRisks}
            unknowns={unknownRisks}
            errors={errorRisks}
          />
        </div>
      </div>
    </div>
  );
};

export default OwnerName;
